export default __webpack_public_path__ + "static/media/NoFlags.777423d0.png";